import { useCallback, useState } from 'react'

export function useOpenState() {
  const [isOpen, setIsOpen] = useState(false)

  const open = useCallback(() => {
    if (!isOpen) setIsOpen(true)
  }, [isOpen])

  const close = useCallback(() => {
    if (isOpen) setIsOpen(false)
  }, [isOpen])

  return {
    isOpen,
    open,
    close,
  }
}
